import { Component, OnInit } from '@angular/core';
import { UserService } from '../_core/services/user.service';
import { User } from '../_shared/models/user.model';
import { NavController } from '@ionic/angular';

@Component({
  standalone: false,
    selector: 'app-settings',
    templateUrl: './settings.page.html',
    styleUrls: ['./settings.page.scss'],
})
export class SettingsPage implements OnInit {
    phone: number;
    authUser: User;

    constructor(
        private userService: UserService,
        private navCtrl: NavController
    ) { }

    ngOnInit() {
        this.getMyProfile();
    }

    getMyProfile() {
        this.userService.myProfile().subscribe(
            (responseSuccess) => {
                this.authUser = responseSuccess.data;
            }
        );
    }

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('cognitoUsername');
        this.navCtrl.navigateRoot('private');
    }

}
